import React from 'react'
import clsx from 'classnames'
import { Stars } from './Stars'
import styles from './StarsWithLabel.module.scss'

type StarsWithLabelProps = {
  title: React.ReactNode,
  name: string,
  value: number,
  onChange?: (value: number) => void,
  className?: string,
  titleClassName?: string,
}

export const StarsWithLabel: React.FC<StarsWithLabelProps> = (props) => {
  const { title, name, value, onChange, className, titleClassName } = props
  return (
    <div className={clsx([styles.container, className])}>
      <div className={clsx([styles.fieldTitle, titleClassName])}>{title}</div>
      <div className={styles.starsContainer}>
        <Stars name={name} value={value} onChange={onChange} />
      </div>
    </div>
  )
}
